"use strict";

var _classCallCheck = require("D:/endimension/radsmart_website/Superprops/Superprops/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("D:/endimension/radsmart_website/Superprops/Superprops/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadPlugin = void 0;

var LinkInstance_1 = require("./LinkInstance");

var Plugin = /*#__PURE__*/function () {
  function Plugin() {
    _classCallCheck(this, Plugin);

    this.id = "links";
  }

  _createClass(Plugin, [{
    key: "getPlugin",
    value: function getPlugin(container) {
      return new LinkInstance_1.LinkInstance(container);
    }
  }, {
    key: "needsPlugin",
    value: function needsPlugin() {
      return true;
    }
  }, {
    key: "loadOptions",
    value: function loadOptions() {}
  }]);

  return Plugin;
}();

function loadPlugin(tsParticles) {
  var plugin = new Plugin();
  tsParticles.addPlugin(plugin);
}

exports.loadPlugin = loadPlugin;